$(document).ready(function () {
  
  $(document).on('click','.btn_toggle', function(){
    $(this).parents('.grid__item').siblings('.grid__item').find('.btn_toggle').removeClass('open');
    $(this).parents('.grid__item').siblings('.grid__item').find('.product_options_wrapper').slideUp();
    $(this).toggleClass('open');
    $(this).next('.product_options_wrapper').slideToggle();
    var popupContent = $('#cart-notification');
    setTimeout(function(){
      popupContent.scrollTop(popupContent[0].scrollHeight);
      
    },400);
  });

  $(document).on("change", ".card-product-radio .input-type-radio", function () {
    $(this).parents('.product-upsell').find('.product-form__submit').removeClass('disabled');
    const allVariants = JSON.parse(
      $(this).parents("fieldset").siblings('[type="application/json"]').text() || "[]"
    );
    const fieldsets = Array.from($(this).parents("fieldset"));
    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
    const currentVariant = allVariants.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return options[index] === option;
        })
        .includes(false);
    });
    currentVariant.id &&
      $(this).parents(".product-upsell").find('product-form [name="id"]').val(currentVariant.id);
  });

  $(document).on('click','.cart-notification__links .close_btn',function(){
    $('.modal__close-button').trigger('click');
  }); 

  settings = {
    //Model Popup
    objModalPopupBtn: ".modalButton",
    objModalCloseBtn: ".overlay, .closeBtn",
    objModalDataAttr: "data-popup",
  };
  $(document).on("click", settings.objModalPopupBtn, function () {
    if ($(this).attr(settings.objModalDataAttr)) {
      event.preventDefault();
      if ($(this).hasClass("disabled")) {
        return;
      }
      var strDataPopupName = $(this).attr(settings.objModalDataAttr);

      if (strDataPopupName == "individuell_modal") {
        setTimeout(function () {
          $(".individuell-nummer-text").focus();
        }, 500);
      }

      //Fade In Modal Pop Up
      $("#" + strDataPopupName).fadeIn();
      $("#" + strDataPopupName)
        .next(".overlay")
        .fadeIn();
      $("body").addClass("overflow-hidden open-popup");

      let closestProductInfo = $(this).closest("product-info");
      let product_form__error_message_wrapper = $(closestProductInfo).find(
        ".product-form__error-message-wrapper"
      );
      let product_form__error_message = $(closestProductInfo).find(
        ".product-form__error-message"
      );
      product_form__error_message_wrapper.attr("hidden", true);
      product_form__error_message.text("");
    }
  });

  //On clicking the modal background
  $(document).on("click", settings.objModalCloseBtn, function () {
    $(".modal").fadeOut();
    $("body").removeClass("overflow-hidden open-popup");
  });
  
});